import * as React from 'react';

import { IContext, context } from './context';

export function useContext(): IContext {
  return React.useContext(context);
}
